import * as actionTypes from './actionTypes';

// NIGHT MODE
export const setActiveSearch = active => {
    return {
        type: actionTypes.SET_ACTIVE_SEARCH,
        active
    }
}
